<ui-icon [icon]="filterKey | filtersIcon" [size]="18" class="flex"></ui-icon>
